import { API_ROUTES } from '@/constants/apiRoutes';
import { PaginatedApiResponse } from '@/react-query/context/ApiClientContextController';
import { queryFactoryOptions } from '@/react-query/utills/queryFactoryOptions';
import { AxiosInstance } from 'axios';
import { AffiliateWithdrawLogDetailParams, MonthlyReportData } from '../payment.types';

const getMonthlyReport = (client: AxiosInstance) => async (params: AffiliateWithdrawLogDetailParams) => {
  return (
    await client.get<PaginatedApiResponse<MonthlyReportData[]>>(API_ROUTES.GET_AFFILIATE_WITHDRAW_LOG_DETAIL, {
      params,
    })
  ).data;
};

export const monthlyReportQueries = {
  all: () => [API_ROUTES.GET_AFFILIATE_WITHDRAW_LOG_DETAIL],

  list: (params: AffiliateWithdrawLogDetailParams) =>
    queryFactoryOptions<PaginatedApiResponse<MonthlyReportData[]>>({
      queryKey: [...monthlyReportQueries.all(), 'list', params],
      queryFn: (client) => () => getMonthlyReport(client)(params),
    }),
};
